export default __webpack_public_path__ + "static/media/570.6f6447c9.png";